/*
 * Comportement JS pour la section custom-header-preheader : initialise
 * theme.Disclosure (ouverture/fermeture au clic) pour le sélecteur de
 * langue/devise, exactement comme theme.FooterSection le fait pour le
 * sien (assets/theme.js). Enregistré via theme.sections.register pour
 * réutiliser le cycle de vie existant (init au chargement de la section,
 * y compris dans l'éditeur de thème via shopify:section:load/unload).
 */
theme.sections.register(
  'custom-header-preheader',
  (function () {
    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]',
    };

    function CustomHeaderPreheaderSection(container) {
      this.container = container;
      this.init();
    }

    CustomHeaderPreheaderSection.prototype = Object.assign({}, CustomHeaderPreheaderSection.prototype, {
      init: function () {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);

        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }

        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }
      },
    });

    return CustomHeaderPreheaderSection;
  })()
);

/*
 * Synchronise le logo (custom-header-logo, position absolute/fixed
 * indépendante) avec l'état sticky du header : theme.js bascule
 * .site-header--stuck puis .site-header--opening sur #SiteHeader
 * (assets/theme.js:6906/8493) au scroll. Pas de hook JS natif pour
 * s'y greffer proprement (register('header', ...) écraserait
 * theme.HeaderSection), donc on observe simplement les mutations de
 * classe et on les reproduit sur le logo — le CSS (custom-header-logo.liquid)
 * fait le reste avec le même timing/easing que le header.
 */
(function () {
  var HEADER_SELECTOR = '#SiteHeader';
  var LOGO_SELECTOR = '.custom-header-logo';
  var LOGO_CLASS_MAP = {
    'site-header--stuck': 'custom-header-logo--stuck',
    'site-header--opening': 'custom-header-logo--opening',
  };

  var observer;

  function syncLogoState(header, logo) {
    Object.keys(LOGO_CLASS_MAP).forEach(function (headerClass) {
      logo.classList.toggle(LOGO_CLASS_MAP[headerClass], header.classList.contains(headerClass));
    });
  }

  function initLogoStickySync() {
    if (observer) {
      observer.disconnect();
    }

    var header = document.querySelector(HEADER_SELECTOR);
    var logo = document.querySelector(LOGO_SELECTOR);

    if (!header || !logo) {
      return;
    }

    syncLogoState(header, logo);

    observer = new MutationObserver(function () {
      syncLogoState(header, logo);
    });
    observer.observe(header, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('DOMContentLoaded', initLogoStickySync);
  document.addEventListener('shopify:section:load', initLogoStickySync);
})();

/*
 * Sélecteur de langue du drawer mobile (custom-drawer-menu.liquid, rendu par
 * custom-header-main.liquid). theme.HeaderSection.initDisclosures() (assets/theme.js)
 * ne câble que les [data-disclosure-locale/-currency] situés À L'INTÉRIEUR du conteneur
 * data-section-id/data-section-type="header" — or #NavDrawer est rendu par render
 * AVANT l'ouverture de ce conteneur, donc en est un frère (sibling), jamais un
 * descendant. Résultat : son bouton ne recevait jamais de listener de clic.
 * Même limitation que CustomHeaderPreheaderSection ci-dessus, mais #NavDrawer n'étant
 * pas lui-même une section Shopify, on la câble ici en pur DOM (comme
 * initLogoStickySync plus bas) plutôt que via theme.sections.register.
 */
(function () {
  var selectors = {
    locale: '#NavDrawer [data-disclosure-locale]',
    currency: '#NavDrawer [data-disclosure-currency]',
  };

  var instances = [];

  function initNavDrawerDisclosures() {
    instances.forEach(function (instance) {
      instance.destroy();
    });
    instances = [];

    document.querySelectorAll(selectors.locale).forEach(function (el) {
      instances.push(new theme.Disclosure(el));
    });
    document.querySelectorAll(selectors.currency).forEach(function (el) {
      instances.push(new theme.Disclosure(el));
    });
  }

  document.addEventListener('DOMContentLoaded', initNavDrawerDisclosures);
  document.addEventListener('shopify:section:load', initNavDrawerDisclosures);
})();

/*
 * Mega menu "liste + aperçu au survol" (layout: hover_preview, voir
 * snippets/custom-header-desktop-nav.liquid). Survoler/focus un item de la
 * liste de gauche active le panneau correspondant à droite (image + titre +
 * description de la collection). Le 1er item est actif par défaut (rendu
 * côté Liquid via forloop.first), ce script ne gère que les changements.
 */
(function () {
  function activate(root, trigger) {
    root.querySelectorAll('[data-megamenu-hover-trigger]').forEach(function (el) {
      el.classList.toggle('megamenu-hover__item--active', el === trigger);
    });

    var targetId = trigger.getAttribute('data-target');
    root.querySelectorAll('.megamenu-hover__panel').forEach(function (panel) {
      panel.classList.toggle('megamenu-hover__panel--active', panel.id === targetId);
    });
  }

  function initMegamenuHoverPreview(root) {
    root.querySelectorAll('[data-megamenu-hover-trigger]').forEach(function (trigger) {
      trigger.addEventListener('mouseenter', function () {
        activate(root, trigger);
      });
      trigger.addEventListener('focusin', function () {
        activate(root, trigger);
      });
    });
  }

  function initAllMegamenuHoverPreviews() {
    document.querySelectorAll('.megamenu-hover').forEach(initMegamenuHoverPreview);
  }

  document.addEventListener('DOMContentLoaded', initAllMegamenuHoverPreviews);
  document.addEventListener('shopify:section:load', initAllMegamenuHoverPreviews);
})();

(function () {
  function neutralizePlaceholderLinks() {
    document.querySelectorAll('summary[data-link="#"]').forEach(function (summary) {
      summary.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
        },
        true
      );
    });
  }

  document.addEventListener('DOMContentLoaded', neutralizePlaceholderLinks);
  document.addEventListener('shopify:section:load', neutralizePlaceholderLinks);
})();
